<template>
  <div class="chart-container">
    <canvas ref="canvas" class="canvas-graph"></canvas>
  </div>
</template>

<script>
import { Line, Bar } from "vue-chartjs";

import ChartSettings from "./chart.settings.js";

import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.defaults.global.legend.display = false;

import moment from 'moment'

export default {
  props: ["currentColor", "secondaryColor"],
  extends: Bar,
  data() {
    return {
      labels: [],
      inside_data: [],
      preorder_data: [],
      delivery_data: [],
      total_data: []
    };
  },
  props: {
    inside: Array,
    delivery: Array,
    preorder: Array
  },
  watch: {
    inside() {
      this.rerender();
    }
  },
  methods: {
    createChartData() {
      if (this.inside.length <= 14) {
        this.labels = this.inside.map(d => moment(d.timestamp, 'DD.MM.YYYY').format('ddd'));
      } else {
        this.labels = this.inside.map(d => d.timestamp);
      }
      this.inside_data = this.inside.map(v => v.visits);
      this.preorder_data = this.preorder.map(v => v.visits);
      this.delivery_data = this.delivery.map(v => v.visits);
      this.total_data = this.inside_data.map((val,index) => {
        return this.inside_data[index] + this.delivery_data[index] + this.preorder_data[index];
      });
    },
    makeChartDataset(color, data) {
      return {
        data,
        backgroundColor: color,
        pointBorderColor: "rgba(0, 0, 0, 0)",
        pointBackgroundColor: "rgba(0, 0, 0, 0)",
        pointHoverBackgroundColor: color,
        pointHoverBorderColor: color,
        lineTension: 0,
        fill: true,
        borderColor: "rgba(0,0,0,0)"
      }
    },
    makeBarDataset(color, data) {
      return {
        data,
        backgroundColor: color,
        hoverBackgroundColor: color
      }
    },
    rerender() {
      this.createChartData();
      this.renderChart(
      {
        labels: this.labels,
        datasets: [
          this.makeBarDataset('#129B81', this.inside_data),
          this.makeBarDataset('#FFD2A8', this.preorder_data),
          this.makeBarDataset('#CBD9E6', this.delivery_data),
          this.makeBarDataset('#464646', this.total_data),
        ]
      },

      {
        scales: ChartSettings.scales,
        /*plugins: {
          datalabels: {
            display: function(context) {
              return context.active;
            }
          }
        */
      }
    );
    }
  },
  mounted() {
    this.addPlugin(ChartDataLabels);

    this.rerender();
  }
};
</script>

<style scoped>
.canvas-graph {
  background: #1d1d1b;
  padding-top: 5vh;
  width: 75vh !important;
  height: 50vh !important;
  border-radius: 0 0 1vh 1vh;
}

.chart-container {
  width: min-content;

  display: block;
}
</style>